import { AequiaMark } from "@/components/ui";

export function AppLoading() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-6 bg-bg text-text"
      role="status"
      aria-live="polite"
    >
      <AequiaMark size={84} />
      <div className="text-[11px] uppercase tracking-eyebrow text-muted font-semibold">
        Cargando sesión…
      </div>
    </div>
  );
}
